import styled from "styled-components";

import colors from "@src/common/styles/colors";
import {
  BREAKPOINTS,
  DEFAULT_MARGIN_L,
  DEFAULT_MARGIN_M,
} from "@src/common/styles/const";
import { defaultLetterSpacing, media } from "@src/common/styles/mixins";
import closeIcon from "@src/modules/shared/components/Modal/ModalHeader/icons/close.svg";

export const ModalHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${DEFAULT_MARGIN_L}px 40px;
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  background-color: ${colors.white};

  ${media.down("MOBILE")`
    padding-left: ${DEFAULT_MARGIN_M}px;
    padding-right: ${DEFAULT_MARGIN_M}px;
  `}

  @media (orientation: landscape) and (max-height: ${BREAKPOINTS.MOBILE
    .max}px) {
    padding: ${DEFAULT_MARGIN_M}px 40px;
  }
`;

export const Text = styled.div`
  ${defaultLetterSpacing};
  color: ${colors.almostBlack};
  font-weight: 600;
  font-size: 18px;
  max-width: 500px;

  ${media.down("MOBILE")`
    font-size: 14px;
    line-height: 19px;
  `}

  ${media.up("QHD")`
    font-size: 32px;
    max-width: 1000px;
  `}
`;

export const CloseIcon = styled.img.attrs({
  src: closeIcon,
})`
  cursor: pointer;
`;
